import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

interface UseFolderDetailMetaParams {
  folderSno: number;
}

export const useFolderDetailMeta = ({
  folderSno,
}: UseFolderDetailMetaParams) => {
  return useQuery({
    queryKey: queryKey.folderDetailMeta(folderSno),
    queryFn: () =>
      likedFolderService.getFolderDetailMeta({ folder_sno: folderSno }),
    placeholderData: keepPreviousData,
  });
};
